import { PromoSidebar } from "./PromoSidebar"

const AuthLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-[#4338ca] relative">
            {/* Add grid overlay */}
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `
                        linear-gradient(#503CDA 1px, transparent 1px),
                        linear-gradient(90deg, #503CDA 1px, transparent 1px)
                    `,
                    backgroundSize: "80px 80px",
                }}
            />

            <div className="sm:hidden">
                <div className="flex flex-col min-h-screen">
                    <div className="flex-1 px-4 py-8 text-center">
                        <PromoSidebar isMobile={true} />
                    </div>
                    <div>
                        <div className="w-full">{children}</div>
                    </div>
                </div>
            </div>

            <div className="hidden sm:flex lg:hidden flex-col items-center justify-center min-h-screen px-8 py-8">
                <div className="w-full max-w-2xl">
                    {/* Top Promo Content for Tablet - Logo and title only */}
                    <div className="mb-8 text-center">
                        <PromoSidebar isTabletTop={true} />
                    </div>

                    {/* Login Form */}
                    <div className="flex justify-center mb-8">
                        <div className="w-full max-w-md">{children}</div>
                    </div>

                    {/* Bottom Promo Content for Tablet - Bullets and exam icons */}
                    <div className="text-center">
                        <PromoSidebar isTabletBottom={true} />
                    </div>
                </div>
            </div>

            {/* Desktop Layout - Side by side */}
            <div className="hidden lg:flex lg:items-center lg:justify-center lg:min-h-screen">
                <div className="max-w-[1200px] flex gap-20">
                    <PromoSidebar />
                    <div className="flex-1 lg:w-[550px] flex items-center justify-center">{children}</div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout
